import React from 'react';

import { Field } from 'formik';

interface CustomInputProps {
	name: string;
	placeholder: string;
	type?: string;
	component?: any;
	options?: any;
	stateSelected?: string | number;
	setStateSelected?: any;
	optionName1?: string;
	fieldValue?: string;
	setFieldValue?: any;
	optionName2?: string;
	formikBag?: any;
	innerIcon?: string | JSX.Element;
	prefixIcon?: string;
	removeSpace?: boolean;
	handleOnChange?: (e) => void;
	maxLength?: number;
	step?: number;
	autoHeight?: boolean;
	autoComplete?: string;
}

const CustomInput: React.FC<CustomInputProps> = ({
	type,
	name,
	placeholder,
	component,
	formikBag,
	innerIcon,
	prefixIcon,
	removeSpace = false,
	handleOnChange = () => {},
	maxLength,
	step,
	autoHeight = false,
	autoComplete,
}) => {
	const ref = React.useRef<any>(null);
	const [nameFocused, setNameFocused] = React.useState(false);

	React.useEffect(() => {
		if (autoHeight && ref?.current) {
			const handleInput = () => {
				const textarea = ref.current;

				if (textarea) {
					textarea.style.height = 'auto';
					textarea.style.height = `${textarea.scrollHeight}px`;
				}
			};
			handleInput();
			ref?.current?.addEventListener('input', handleInput);

			return () => {
				ref?.current?.removeEventListener('input', handleInput);
			};
		}
	}, [ref]);

	return (
		<div
			className={
				formikBag.errors[name] && formikBag.touched[name]
					? nameFocused
						? 'custom-input error focused '
						: formikBag.values[name]?.length
							? 'custom-input filled error'
							: 'custom-input error'
					: nameFocused
						? 'custom-input focused'
						: formikBag.values[name]?.length || typeof formikBag.values[name] === 'number'
							? 'custom-input filled'
							: 'custom-input'
			}
			onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
				if (removeSpace) {
					formikBag.setFieldValue(name, event.target.value.trim());
				}
				handleOnChange(event);
			}}
			onFocus={(event) => setNameFocused(true)}
		>
			{prefixIcon && (
				<div className="custom-input__prefix-icon">
					<img src={prefixIcon} alt="img" />
				</div>
			)}
			<Field
				innerRef={ref}
				maxLength={maxLength}
				step={step}
				type={type}
				component={component}
				name={name}
				placeholder={placeholder}
				id={name}
				autoComplete={autoComplete || name}
			/>
			<div className="custom-input__inner-icon">{innerIcon ?? null}</div>
			<div className="custom-input__error">{formikBag.errors[name] && formikBag.touched[name] ? formikBag.errors[name] : null}</div>
			<div className="custom-input__placeholder-top">{placeholder}</div>
		</div>
	);
};

export default CustomInput;
